module.exports = __webpack_public_path__ + "house-blueprint-deep.57c3211ff49b50732604.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/house-blueprint-deep.svg
// module id = ../../../../../src/assets/img/house-blueprint-deep.svg
// module chunks = main